import { Box } from '@mui/material';
import { useRouter } from 'next/router';
import React from 'react';

import { useEmbedded } from 'hooks/useEmbedded';
import { usePageEventByQuery } from 'queries/events/usePageEventByQuery';

import MdlbeastEmbed from 'components/@events/MdlbeastEmbed';
import AppNavigation from 'components/@navigation/AppNavigation';
import PageBreadcrumbs from 'components/@navigation/PageBreadcrumbs';
import PageSeo from 'components/@seo/PageSeo';

const EventProgramIframePage = () => {
  const router = useRouter();
  const { slug, path, name } = router.query;
  const { isEmbedded } = useEmbedded();
  const { event } = usePageEventByQuery();

  // Use path from query parameter if provided, otherwise fallback to first program's path
  const programPath = (path as string) || event?.programs?.[0]?.xpProgramPath;

  // Breadcrumb items
  const breadcrumbItems = slug
    ? [
        {
          href: `/events/${slug}`,
          label: event?.title || 'Event',
        },
        {
          label: name,
        },
      ]
    : [
        {
          label: 'Back',
          onClick: () => router.back(),
        },
        { label: 'Program' },
      ];

  return (
    <AppNavigation hideFooterOnMobile={isEmbedded}>
      <PageSeo tags={event?.seoTags} />
      <Box sx={{ px: { xs: 2, md: 3 }, pt: 2 }}>
        <PageBreadcrumbs items={breadcrumbItems} />
      </Box>

      {programPath && (
        <MdlbeastEmbed path={programPath} title={`${event?.title} Program`} />
      )}
    </AppNavigation>
  );
};

export default EventProgramIframePage;
